import React from "react";
import { AppListing } from "../../../../components/appListing";
import { eventCols } from "../../constant";

const CareplanEvents = ({ listData = [], loading = false }) => {
  return (
    <div className="py-2">
      <AppListing
        loading={loading}
        listData={listData}
        cols={eventCols}
      />
    </div>
  );
};

export default CareplanEvents;
